module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_yogasix-cf5205fd15dcfd1266d4229b297d0acc.png";